
<div class="d-flex mt-1 ">

  <div class="grid formgrid p-fluid ">
    <!-- <div *ngIf="!isRespigimento"></div> -->
      <div *ngIf="!isBocciaturaPresidio && !isRespigimento && !pratica.isRetOK" class="field col-12">
        <label for="noteRET" >Note <strong>RET</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteRET" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteRET}}</textarea>
        </span>
      </div>
      <div *ngIf="!isBocciaturaPresidio && !isRespigimento && !pratica.isDuvriOK" class="field col-12">
        <label for="noteDUVRI" >Note <strong>DUVRI</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteDUVRI" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteDUVRI}}</textarea>
        </span>
      </div>
      <div *ngIf="!isBocciaturaPresidio && !isRespigimento && !pratica.isVerbaleOK" class="field col-12">
        <label for="noteVERBALE">Note <strong>VERBALE DI SOPRALLUOGO</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteVERBALE" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteVerbale}}</textarea>
        </span>
      </div>
    
      <div *ngIf="!isBocciaturaPresidio && isRespigimento" class="field col-12">
        <label for="noteVERBALE">Note <strong> INFRATEL</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteVERBALE" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteBocciaturaInfratel.toUpperCase()}}</textarea>
        </span>
     </div>

     <div *ngIf="isBocciaturaPresidio" class="field col-12">
<!--       <label for="noteVERBALE">Note <strong> INFRATEL</strong></label>
 -->      <span class="p-input-icon-left">
        <i class="pi pi-info-circle"></i>
        <textarea id="noteBocciaturaPresidio" rows="3" [autoResize]="true" class="font-bold"  pInputTextarea [disabled]="true">{{pratica.noteBocciaturaPresidio.toUpperCase()}}</textarea>
      </span>
   </div>
  </div>
<div class=" mt-2" style="text-align: center;">
  <button *ngIf="!isBocciaturaPresidio" pButton pRipple icon="pi pi-cloud-download" (click)="scaricaReport()" label="SCARICA REPORT" class="p-button-outlined w-5 mt-1 mr-1"></button>

  <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="p-button-outlined w-5 mt-1"></button>
</div> 
<p-toast />
<p-confirmDialog /> 